import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export function NativeSelect({
  size: _size,
  className,
  ...props
}: Omit<ComponentProps<"select">, "size"> & { size?: "sm" | "default" }) {
  return <select {...props} data-slot="native-select" className={cn("cyra-input", className)} />;
}
export const NativeSelectOption = surface("option", "native-select-option");
export const NativeSelectOptGroup = surface("optgroup", "native-select-optgroup");
